import request from '@/utils/request'

/**
 * 分页
 * @param {*} data
 * @returns
 */
export function page(data) {
  return request({
    url: '/mg/daohang-basic-api/retailShop/page',
    method: 'post',
    data,
  })
}
/**
 * 列表
 * @param {*} data
 * @returns
 */
export function list(data) {
  return request({
    url: '/mg/daohang-basic-api/retailShop/list',
    method: 'post',
    data,
  })
}
/**
 * 保存
 * @param {*} data
 * @returns
 */
export function save(data) {
  return request({
    url: '/mg/daohang-basic-api/retailShop',
    method: 'put',
    loading: true,
    data,
  })
}

/**
 * 保存
 * @param {*} data
 * @returns
 */
export function changeStatus(data) {
  return request({
    url: '/mg/daohang-basic-api/retailShop/status',
    method: 'post',
    loading: true,
    data,
  })
}
/**
 * 详情
 * @param {*} data
 * @returns
 */
export function detail(params) {
  return request({
    url: '/mg/daohang-basic-api/retailShop/itemList',
    method: 'get',
    params,
  })
}
/**
 * 根据门店编码查询门店详情
 * @param {*} data
 * @returns
 */
export function getDetailByShopCode(shopCode) {
  return request({
    url: `/mg/daohang-basic-api/retailShop/detail/${shopCode}`,
    method: 'get',
  })
}

/**
 * 保存
 * @param {*} 导出
 * @returns
 */
export function pageExport(data) {
  return request({
    url: '/mg/daohang-basic-api/retailShop/exportExcel',
    method: 'post',
    responseType: 'blob',
    data,
  })
}
//当前往来单位启用状态的逻辑仓列表&&排除当前往来单位下的门店（启用&禁用）关联的仓库
export function queryCargoWarehouses(data) {
  return request({
    url: '/mg/daohang-basic-api/retailShop/queryCargoWarehouses',
    method: 'post',
    loading: true,
    data,
  })
}
